/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { xBaseTheme } from "@monsma/XDL/types";

export default {
    1: "0 8px rgba(188, 194, 47, 1)",
    2: "inset 0 6px 0 0 rgba(18, 22, 88, 1), 0 2px 4px 0 rgba(0, 0, 0, 0.15)",
    3: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
    4: `0 -1px rgb(219, 216, 204)`,
    5: "0 -6px 0 0 rgba(18, 22, 88, 1), 0 2px 4px 0 rgba(0, 0, 0, 0.15)", // same as 2 without inset
} as xBaseTheme["shadows"];
